// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--mTzLi","link":"a10a3f92e9--link--A5SdC"};